import Grid from "./Grid";

export default class Sort extends Grid {
  get CLASSES() {
    return {
      isSelected: 'is-selected',
    }
  }

  constructor() {
    super();
    this.$sort = document.querySelector('[data-sort]')
    if (!this.$sort) return;
    this.$buttons = [...document.querySelectorAll('[data-category-target]')];
    this.$targets = [...document.querySelectorAll('[data-category-id]')]
    this.urlParams = new URLSearchParams(window.location.search);
    this.tag = this.urlParams.get('tag');
    this.clone;
    this.initSort();
  }

  initSort() {
    this.onSortClicked();
  }

  onSortClicked() {
    this.$buttons.forEach(button => {
      button.addEventListener('click', clickedButton => {
        if (this.tag) {
          this.urlParams.delete('tag');
        }
        if (button.classList.contains(this.CLASSES.isSelected)) {
          this.removeClass(this.$buttons)
        } else {
          this.removeClass(this.$buttons)
          this.addClass(clickedButton)
        }
        
        this.clone = []

        this.$targets.forEach((item) => {
          this.clone.push(item);
          item.remove();
        });

        this.clone.forEach(item => {
          const target = clickedButton.currentTarget.dataset.categoryTarget;
          const categoryId = item.dataset.categoryId;

          const fadeTl = gsap.timeline({ defaults: { duration: 0.3, ease: 'none' }});
          fadeTl
            .to(this.$grid, {
              opacity: 0,
              onComplete: () => {
                this.hide(item);
                if (button.classList.contains(this.CLASSES.isSelected)) {
                  this.show(item, target, categoryId);
                } else {
                  this.createAll(item)
                }
              }
            },)
            .to(this.$grid, {
              opacity: 1,
            }, '+=0.5')
        });
      });
    });
  }

  addClass(element) {
    element.target.classList.add(this.CLASSES.isSelected);
  }

  removeClass(elements) {
    elements.forEach(button => {
      button.classList.remove(this.CLASSES.isSelected);
    });
  }

  createItem(element) {
    this.$grid.appendChild(element);
    setTimeout(() => this.createGrid());
  }

  createAll(element) {
    this.createItem(element)
  }

  show(element, target, categoryId) {
    if (categoryId.includes(',')) {
      const array = element.dataset.categoryId.split(',');
      array.forEach(id => {
        if (target === id) {
          this.createItem(element)
        }
      });
    } else {
      if (target === categoryId) {
        this.createItem(element)
      }
    }

    if (target === 'all') {
      this.createAll(element)
    }
  }

  hide(element) {
    element.remove();
  }
}
